// Curated public SQLite datasets that users can import from a one-click
// menu. All entries are served from raw.githubusercontent.com which sends
// `access-control-allow-origin: *`, so browser-side fetch works without
// any proxy. This is the only network call YesQL makes — every other
// operation is local-only.

export interface RemoteDataset {
  id: string;
  /** Display name in the picker. */
  name: string;
  /** Suggested local database name (collisions auto-suffix). */
  dbName: string;
  /** One-line summary shown beneath the name. */
  description: string;
  /** Approximate download size in bytes. Used purely for the UI hint;
   *  actual size comes from the response body. */
  bytes: number;
  /** Direct file URL. Must serve CORS for browser fetch to work. */
  url: string;
  /** Where the dataset is hosted (shown to the user as the network
   *  destination — they have a right to know what we're talking to). */
  source: string;
  /** Upstream project URL for attribution. */
  homepage: string;
  /** SPDX-style license identifier where known. */
  license: string;
}

export const REMOTE_DATASETS: RemoteDataset[] = [
  {
    id: 'chinook',
    name: 'Chinook',
    dbName: 'chinook',
    description: 'Digital music store — 11 tables, ~15K rows. The classic SQL teaching dataset.',
    bytes: 1_007_616,
    url: 'https://raw.githubusercontent.com/lerocha/chinook-database/master/ChinookDatabase/DataSources/Chinook_Sqlite.sqlite',
    source: 'raw.githubusercontent.com',
    homepage: 'https://github.com/lerocha/chinook-database',
    license: 'MIT',
  },
  {
    id: 'northwind',
    name: 'Northwind',
    dbName: 'northwind',
    description:
      "Microsoft's classic Northwind Traders sample — 13 tables, ~3K rows of orders, products, customers, employees.",
    bytes: 24_702_976,
    url: 'https://raw.githubusercontent.com/jpwhite3/northwind-SQLite3/main/dist/northwind.db',
    source: 'raw.githubusercontent.com',
    homepage: 'https://github.com/jpwhite3/northwind-SQLite3',
    license: 'MIT',
  },
];
